// Fail closed for empty, failed, or truncated searches. Material/part filters
// must not turn a vehicle that has covers into a foam-only vehicle.
export const isFoamOnlyResponse = response => {
    const hits = response?.hits || [];
    return hits.length > 0
        && response.nbHits === hits.length
        && response.exhaustiveNbHits !== false
        && hits.every(hit => /foam/i.test(hit.options?.part || ''));
};
